export function metersToFeet(meters) {
    return meters * 3.2808;
}

export function feetToMeters(feet) {
    return feet / 3.2808;
}

export function shortUnitsName(units) {
    return units === 'metric' ? 'm' : 'ft';
}

export function distanceValueToShow(units, value) {
    return units === 'metric'
        ? parseFloat(value).toFixed(0)
        : parseFloat(metersToFeet(value)).toFixed(0);
}

export function distanceValueToUpload(units, value) {
    if (value) {
        return units === 'metric'
            ? parseFloat(value).toFixed(0)
            : parseFloat(feetToMeters(value)).toFixed(0);
    } else {
        return null;
    }
}